const CircularProgress = ({ value = 25, size = 180, strokeWidth = 12, fontsize = 16, strokeColor = "#4285F4" }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = (value / 100) * circumference;

  return (
    <div className="flex items-center justify-center">
      <div className="relative" style={{ width: size, height: size }}>
        {/* Background Circle */}
        <svg className="transform -rotate-90" width={size} height={size}>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="#E5E7EB" // Tailwind gray-200
            strokeWidth={strokeWidth}
            fill="none"
          />
          {/* Progress Circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            fill="none"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={circumference - progress}
          />
        </svg>
        {/* Center Text */}
        <div className="absolute inset-0 flex items-center justify-center font-bold text-gray-900"
        style={{ fontSize: fontsize }}>
          {value}
        </div>
      </div>
    </div>
  );
};

export default CircularProgress;
